import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AdminAssessmentHashtagsEditComponent } from "./admin-assessment-hashtags-edit.component";
import { InvoiceFormModule } from "../../admin-invoices-list/invoice-form/invoice-form.module";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { TranslateModule } from "@ngx-translate/core";
import { ExplanationLabelModule } from "../../../../../../../../common-ui/src/lib/explanation-label/explanation-label.module";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { ReactiveFormsModule } from "@angular/forms";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzInputModule } from "ng-zorro-antd/input";

@NgModule({
  declarations: [AdminAssessmentHashtagsEditComponent],
  imports: [
    CommonModule,
    InvoiceFormModule,
    NzButtonModule,
    NzWaveModule,
    TranslateModule,
    ExplanationLabelModule,
    NzFormModule,
    NzGridModule,
    NzInputModule,
    ReactiveFormsModule,
    NzModalModule,
  ],
})
export class AdminAssessmentHashtagsEditModule {}
